import React from "react";
import { HelpIcon, PicklebetIcon, StarIcon, TermsIcon } from "@picklebet/ui";
import * as support from "@/utilities/support";
import type { NavItem } from "../types";
import { action, link } from "./shared";

export const logoId = "logo";

export const logo = (homeUrl: string): NavItem => ({
  id: logoId,
  text: "Picklebet",
  icon: <PicklebetIcon />,
  target: link(homeUrl),
  activeWhen: () => false,
});

export const promotions: NavItem = {
  id: "promotions",
  text: "Promotions",
  icon: <StarIcon />,
  target: link("/promotions"),
};

export const terms: NavItem = {
  id: "terms",
  text: "Terms",
  icon: <TermsIcon />,
  target: action(() => support.open({ labels: ["terms button"] })),
};

export const helpdesk: NavItem = {
  id: "support",
  text: "Support",
  icon: <HelpIcon />,
  target: action(() => support.open({ labels: ["start article"] })),
};
